// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"0e2379a1","453":"144633f3"}[chunkId] + ".chunk.js";
};